import { render, staticRenderFns } from "./RestrictedVisitorCard.vue?vue&type=template&id=64b10e32&scoped=true"
import script from "./RestrictedVisitorCard.vue?vue&type=script&lang=js"
export * from "./RestrictedVisitorCard.vue?vue&type=script&lang=js"
import style0 from "./RestrictedVisitorCard.vue?vue&type=style&index=0&id=64b10e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b10e32",
  null
  
)

export default component.exports